<template>
	<div class="postcode-manager__map">
		<section class="postcode-manager__active-feature sections sections--flexed">
			<div class="section postcode-manager__search">
				<v-tags
					:datasets="typeahead" :tag-label="option => option.display"
					v-on:tag-added="tagAdded"
					v-on:new-tag-attempted="locate"
					v-on:tag-deleted="tagDeleted"
					ref="tags"/>
			</div>
			<dl class="section">
				<dt v-if="!searchedOutwards.length && !selectedOutwards.length">Todays Outwards</dt>
				<dt v-if="searchedOutwards.length && !selectedOutwards.length">Searched Outwards</dt>
				<dt v-if="selectedOutwards.length">Selected Outwards</dt>
				<dd v-if="!stats.numberOfOutwards">-</dd>
				<dd v-if="stats.numberOfOutwards" v-html="stats.numberOfOutwards"/>
			</dl>
			<dl class="section">
				<dt>Searches</dt>
				<dd v-if="!stats.numberOfSearches">-</dd>
				<dd v-if="stats.numberOfSearches" v-html="stats.numberOfSearches"/>
			</dl>
			<dl class="section">
				<dt>Leads</dt>
				<dd v-if="!stats.numberOfLeads">-</dd>
				<dd v-if="stats.numberOfLeads" v-html="stats.numberOfLeads"/>
			</dl>
			<dl class="section">
				<dt>Instructions</dt>
				<dd v-if="!stats.numberOfInstructions">-</dd>
				<dd v-if="stats.numberOfInstructions" v-html="stats.numberOfInstructions"/>
			</dl>
		</section>
		<div class="postcode-manager__map__container">
			<div ref="mapContainer"></div>
		</div>
		<!--		<dl-->
		<!--			class="postcode-manager__feedback flex gap-2"-->
		<!--			v-if="Boolean(this.google) && Boolean(this.map)">-->
		<!--			<div class="flex gap-1">-->
		<!--				<dt>Latitude</dt>-->
		<!--				<dd v-html="currentMapCenter.degrees.lat"/>-->
		<!--				<dd v-html="currentMapCenter.dms.lat"/>-->
		<!--			</div>-->
		<!--			<div class="flex gap-1">-->
		<!--				<dt>Longitude</dt>-->
		<!--				<dd v-html="currentMapCenter.degrees.lng"/>-->
		<!--				<dd v-html="currentMapCenter.dms.lng"/>-->
		<!--			</div>-->
		<!--		</dl>-->
		<outward
			v-for="(outward, outwardIndex) in displayedOutwards" :key="outwardIndex" :google="google" :map="map"
			:outward="outward"
			:selected="selectedOutwards.indexOf(outward) > -1"
			:min-searches="minSearches"
			:max-searches="maxSearches"
			v-on:outward-deselected="outwardDeselected"
			v-on:outward-selected="outwardSelected"
			v-on:outward-mousedover="mousedOver"
			v-on:outward-mousedout="mousedOut"/>
	</div>
</template>
<script>
import GoogleMapGeometry from "../../../../components/maps/GoogleMapGeometry";
import GoogleMapLoader from "../../../../components/maps/GoogleMapLoader";
import GoogleMapMarker from "../../../../components/maps/GoogleMapMarker";
import Outward from "../../../../components/maps/Outward";
import {apiKey, mapSettings} from "../../../../constants/mapSettings";

export default {
	extends: GoogleMapLoader,

	components: {
		GoogleMapGeometry,
		GoogleMapMarker,
		Outward,
	},

	data() {
		return {
			apiKey: apiKey,
			selectedTags: [],
			daysOutwards: [],
			searchedOutwards: [],
			selectedOutwards: [],
			showStats: false,
			hoveredOutward: null,
			typeahead: null,
			markers: [
				{id: "a", position: {lat: 3, lng: 101}},
			],
			unlinked: [],
		};
	},

	computed: {
		displayedOutwards() {
			if (this.searchedOutwards.length) {
				return this.searchedOutwards;
			}

			return this.daysOutwards;
		},
		metricOutwards() {
			if (this.selectedOutwards.length) {
				return this.selectedOutwards;
			}

			if (this.searchedOutwards.length) {
				return this.searchedOutwards;
			}

			return this.daysOutwards;
		},
		stats() {
			return {
				numberOfOutwards: this.metricOutwards.length,
				numberOfSearches: _.sumBy(this.metricOutwards, function (outward) {
					return outward.postcode_searches.length;
				}),
				numberOfLeads: _.sumBy(this.metricOutwards, function (outward) {
					return _.sumBy(outward.postcode_searches, function (search) {
						return search.comparison.leads.length;
					});
				}),
				numberOfInstructions: _.sumBy(this.metricOutwards, function (outward) {
					return _.sumBy(outward.postcode_searches, function (search) {
						return search.comparison.instructions.length;
					});
				}),
			};
		},
		class() {
			return "section section--expanded section--highlight postcode-manager " + (
				this.fullScreen ? "fullscreen" : ""
			);
		},
		mapConfig() {
			return {
				...mapSettings,
				center: this.mapCenter
			};
		},
		mapCenter() {
			var self = this;
			var location = "United Kingdom";
			this.geocoder.geocode({"address": location}, function (results, status) {
				if (status == this.google.maps.GeocoderStatus.OK) {
					location = results[0].geometry.location;
					self.map.fitBounds(results[0].geometry.bounds);
					return location;
				}
			});
			return this.markers[0].position;
		},
		liveTracking() {
			return !this.searchedOutwards.length && !this.selectedTags.length;
		},
		outwardsWithSearches() {
			if (!this.searchedOutwards.length) {
				return [];
			}

			return _.filter(this.searchedOutwards, function (outward) {
				return outward.postcode_searches.length;
			});
		},
		minSearches() {
			if (!this.displayedOutwards.length) {
				return null;
			}

			return _.minBy(this.displayedOutwards, function (outward) {
				return outward.postcode_searches.length;
			}).postcode_searches.length;
		},
		maxSearches() {
			if (!this.displayedOutwards.length) {
				return null;
			}

			return _.maxBy(this.displayedOutwards, function (outward) {
				return outward.postcode_searches.length;
			}).postcode_searches.length;
		},
		flyToOutward() {
			return !this.selectedOutwards.length && !this.searchedOutwards.length;
		},
	},

	methods: {
		clearSelection() {
			this.selectedOutwards = [];
		},
		fitOutwards() {
			var self = this;
			var bounds = new self.google.maps.LatLngBounds();
			_.forEach(this.searchedOutwards, function (outward) {
				_.forEach(outward.coords[0], function (latLng) {
					bounds.extend(new self.google.maps.LatLng(latLng));
				});
			});
			self.map.fitBounds(bounds);
		},
		metrics() {
			this.showStats = !this.showStats;
		},
		tagAdded(tag) {
			this.selectedTags.push(tag);
			// this.$refs.tags.
			http().get("tools/postcode-manager/outwards", {
				params: {
					outwards: tag.identify
				}
			}).then(response => {
				let self = this;
				_.each(response.data.outwards, function (outward) {
					self.searchedOutwards.push(outward);
				});
				self.fitOutwards();
			});
		},
		locate(search) {
			var self = this;
			var geo = new this.google.maps.Geocoder();
			geo.geocode({address: search}, function (resultsFromString, status) {
				if (status != this.google.maps.GeocoderStatus.OK) {
					return;
				}
				self.map.setCenter(resultsFromString[0].geometry.location);
				self.map.fitBounds(resultsFromString[0].geometry.viewport);
				geo.geocode({location: resultsFromString[0].geometry.location}, function (resultsFromLocation, status) {
					if (status != this.google.maps.GeocoderStatus.OK) {
						return;
					}
					var r = _.find(resultsFromLocation, function (result) {
						return _.find(result.address_components, function (address) {
							return _.indexOf(address.types, "postal_code_prefix") > 0;
						});
					});
					if (!r) {
						return;
					}
					r = _.find(r.address_components, function (component) {
						return _.indexOf(component.types, "postal_code_prefix") > 0;
					});
					if (!r) {
						return;
					}
					var area = r.short_name.split(/[0-9]/)[0];
					var outwards = _.filter(self.searchedOutwards, function (outward) {
						return outward.area == area;
					});
					outwards = _.map(outwards, function (outward) {
						return outward.outward;
					});
					var newTag = {
						display: area,
						identify: area,
						type: "area",
						outwards: outwards,
					};
					self.$refs.tags.addTag(newTag);
				});
			});
		},
		tagDeleted(index, tag, tags) {
			this.selectedTags.splice(index, 1);
			this.searchedOutwards = _.filter(this.searchedOutwards, function (outward) {
				return tag.outwards.indexOf(outward.outward) === -1;
			});
			this.selectedOutwards = _.filter(this.selectedOutwards, function (outward) {
				return tag.outwards.indexOf(outward.outward) === -1;
			});
		},
		typeaheadSelected(e, suggestion) {
			this.selection = suggestion;
			this.get();
		},
		toggleFullScreen() {
			this.fullScreen = !this.fullScreen;
		},
		clearSelectedOutwards() {
			this.selectedOutwards = [];
		},
		mousedOver(outward) {
			this.hoveredOutward = outward;
		},
		mousedOut() {
			this.hoveredOutward = null;
		},
		outwardSelected(outward) {
			this.selectedOutwards.push(outward);
		},
		outwardDeselected(outward) {
			this.selectedOutwards.splice(this.selectedOutwards.indexOf(outward), 1);
		},
		goto(outwardLabels) {
			var self = this;
			var bounds = new self.google.maps.LatLngBounds();
			var outwards = _.filter(this.daysOutwards, function (outward) {
				return outwardLabels.indexOf(outward.outward) >= 0;
			});
			_.forEach(outwards, function (outward) {
				_.forEach(outward.coords[0], function (latLng) {
					bounds.extend(new self.google.maps.LatLng(latLng));
				});
			});
			self.map.fitBounds(bounds);
		},
		initialize() {
			var self = this;
			var geo = new this.google.maps.Geocoder();

			geo.geocode({address: "United Kingdom"}, function (results, status) {
				if (status === "OK") {
					self.map.setCenter(results[0].geometry.location);
					self.map.fitBounds(results[0].geometry.viewport);
				}
			});
		},
		updateOutward(event) {
			var self = this;
			http().get(this.route("postcode-geometries/:postcodeGeometry", event.id)).then(response => {
				var newOutward = response.data;

				this.updateOrPush(newOutward, self.daysOutwards);
				this.updateOrPush(newOutward, self.searchedOutwards, false);
				this.updateOrPush(newOutward, self.selectedOutwards, false);

				if (this.flyToOutward) {
					self.gotoOutward(newOutward);
				}
			});
		},
		updateOrPush(newOutward, collection, push = true) {
			let index = _.findIndex(collection, function (outward) {
				return outward.id === newOutward.id;
			});

			if (index > -1) {
				collection.splice(index, 1, newOutward);
			} else if (push) {
				collection.push(newOutward);
			}
		},
		gotoOutward(outward) {
			var bounds = new self.google.maps.LatLngBounds();
			_.forEach(outward.coords[0], function (latLng) {
				bounds.extend(new self.google.maps.LatLng(latLng));
			});
			this.map.fitBounds(bounds);
		}
	},

	created() {
		http().get("tools/postcode-manager").then(response => {
			this.typeahead = response.data.typeahead;
			this.daysOutwards = response.data.daysOutwards;
			this.unlinked = response.data.unlinked;
		});

		window.Echo.private("postcodeManager")
			.listen("PostcodeSearched", (e) => {
				this.updateOutward(e);
			});
	},
};
</script>

